import styled from "styled-components/macro";
import { ChartPluginsProps } from "../../types";
import { BORDER_WIDTH } from "./SkuRowColumn";
import { ONE_MINUTE_OF_MS } from "utils/timeUtils";

export function TeamSizeColumn({
  dimensions,
  teamSizeChangesHistory,
}: {
  dimensions: {
    height: number;
    width: number;
  };
  teamSizeChangesHistory: ChartPluginsProps["teamSizeChangesHistory"];
}) {
  return (
    <TeamSizeColumnStyles {...{ $dimensions: dimensions }}>
      {teamSizeChangesHistory.map(({ teamSize, ge, lt }) => {
        const duration = lt - ge;
        if (duration < 0) {
          console.warn("⚠ ~ negative DDA duration?", duration, { ge, lt });
        }
        const tiny = duration < 30 * ONE_MINUTE_OF_MS;
        return (
          <div
            key={`${ge}-${lt}-team-size-${teamSize}`}
            className={`head-count${tiny ? " tiny" : ""}`}
            style={{
              flexGrow:
                teamSizeChangesHistory.length === 1 // if it's the only team size, grow to 100%
                  ? 1
                  : duration,
            }}
          >
            <div className="text">{teamSize}</div>
            <div className="line" />
          </div>
        );
      })}
    </TeamSizeColumnStyles>
  );
}
const TeamSizeColumnStyles = styled.div<{
  $dimensions: {
    height: number;
    width: number;
  };
}>`
  transform: translateY(-1px);
  height: ${({ $dimensions }) => $dimensions.height - BORDER_WIDTH * 2}px;
  display: flex;
  gap: 2px;
  flex-direction: column;
  .text {
    height: 0px;
  }
`;
